var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    stroke: "transparent",
    d: "M22.707 1.293a1 1 0 0 0-1.414 0L16.9 5.686A7.95 7.95 0 0 0 12 4a8 8 0 0 0-8 8c0 1.849.633 3.546 1.686 4.9l-4.393 4.393a.999.999 0 1 0 1.414 1.414L7.1 18.314A7.96 7.96 0 0 0 12 20a8 8 0 0 0 8-8 7.96 7.96 0 0 0-1.686-4.9l4.393-4.393a1 1 0 0 0 0-1.414zM6 12c0-3.309 2.691-6 6-6 1.294 0 2.49.416 3.471 1.115l-8.356 8.356A5.96 5.96 0 0 1 6 12zm12 0c0 3.309-2.691 6-6 6a5.96 5.96 0 0 1-3.471-1.115l8.356-8.356A5.96 5.96 0 0 1 18 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.90ae570b3986cbdd31bc73438241c76b.svg";
export { ForwardRef as ReactComponent };